
<input type="{{type}}" id="{{getFieldName()}}" name="{{getFieldName()}}" [formControl]="field" class="form-control"
       [ngClass]="{ 'is-invalid': submitted && field && field.errors }">
<app-form-error [field]="field" [submitted]="submitted"></app-form-error>